import { render } from "./FeeNoticesCreate.vue?vue&type=template&id=3be463d8&scoped=true"
import script from "./FeeNoticesCreate.vue?vue&type=script&lang=js"
export * from "./FeeNoticesCreate.vue?vue&type=script&lang=js"

import "./FeeNoticesCreate.vue?vue&type=style&index=0&id=3be463d8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be463d8"]])

export default __exports__